'use client';

import { useEffect } from 'react';
import { trackViewItem, type ViewItemParams } from '../lib/analytics';

/**
 * Client component that fires a GA4 view_item event on mount.
 * Drop into any server-rendered page that needs page-level tracking.
 */
export default function TrackPageView(props: ViewItemParams) {
  useEffect(() => {
    trackViewItem(props);
  }, [props.entityId]); // eslint-disable-line react-hooks/exhaustive-deps

  return null; // renders nothing
}
